import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/Login.css';
import logoRafaGuru from '../images/logo-rafa-guru.png'
import '../styles/Logo.css';


const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setMessage('Un momento por favor.');
      // await axios.post('http://localhost:8882/rafa_login', { email, password })
      await axios.post('https://services.neuralactions.com/api/rafa_login', { email, password })
      .then(response => {
        console.log(response)
        console.log('Login successful:');
        const token = response.data.token;
        localStorage.setItem('token', token); // Guarda el token en localStorage
        console.log('Token guardado:', token);
        const token_expiration = response.data.token_expiration;
        localStorage.setItem('token_expiration', token_expiration); // Guarda el token en localStorage
        const user_id = response.data.user_id;
        localStorage.setItem('user_id', user_id); // Guarda el token en localStorage
        // Redirecciona a NeuralActions
        // window.location.href = 'https://app.neuralactions.com';
        // Redirigir al iframe
        navigate('/');        
      })
      .catch(error => {
          setMessage('Hubo un error. Inténtalo nuevamente.');
          console.error('Error en el login limpiando token:', error);
          const token = '';
          localStorage.setItem('token', token);
      });
    } catch (error) {
      console.error('Error logging in:', error);
      setMessage('Hubo un error. Inténtalo nuevamente.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Bienvenido a Rafa Gurú</h2>
        <div>
            <img src={logoRafaGuru} className="imagen-logo" alt="Rafa Guru"/>
        </div>
        <form onSubmit={handleSubmit}>
          <input 
            type="email" autoComplete="email"
            placeholder=" Ingresa tu correo" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className="input-field"
          />
          <input autoComplete="current-password"
            type="password" 
            placeholder="Ingresa tu contraseña" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className="input-field"
          />
          <button type="submit" className="submit-btn">Entrar a Rafa Gurú</button>
        </form>
        {message && <p className="message">{message}</p>}
        {/* Contenedor de botones para evitar ensanchamiento */}
        <div className="button-container">
          <button className="register-btn" onClick={() => navigate('/register')}>No tengo cuenta</button>
          {/* <button className="register-btn" onClick={() => window.location.href = 'https://app.rafa.guru/register'}>Register</button> */}
          <button className="forgot-password-btn" onClick={() => navigate('/forgot_password')}>Olvidé la clave</button> 
        </div>
      </div>
    </div>
  );
};

export default Login;
